// utils/lazyWithRetry.js
import { lazy } from 'react';

export function lazyWithRetry(componentImport) {
  return lazy(async () => {
    const hasRefreshed = JSON.parse(
      window.sessionStorage.getItem('chunk-refreshed') || 'false'
    );
    try {
      const component = await componentImport();
      window.sessionStorage.setItem('chunk-refreshed', 'false');
      return component;
    } catch (error) {
      if (!hasRefreshed) {
        window.sessionStorage.setItem('chunk-refreshed', 'true');
        window.location.reload();
        return new Promise(() => {});
      }
      throw error;
    }
  });
}